<div class="import-details-note">
  <i class="fas fa-file-import" aria-hidden="true"></i>
  <p class="import-details-text" dir="auto">{{ note.text }}</p>
  <button *ngIf="!readOnly" type="button" class="import-details-remove" (click)="remove.emit()">
    <img src="assets\img\clear_input.svg" alt="" />
  </button>
</div>
